import ReportBuilder from './ReportBuilder';
import InfoIcon from "@mui/icons-material/Info";
import Row from "react-bootstrap/Row";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import TabPanel from "@mui/lab/TabPanel";
import ReportScheduler from './ReportScheduler';
import ScheduleIcon from '@mui/icons-material/Schedule';
import {
  REPORTS_BUILDER,
  REPORTS_SCHEDULER,  
} from "../../Constants/RolesConstants";

let TABS = [
  {
    label: REPORTS_BUILDER,
    Component: ReportBuilder,
    icon: <InfoIcon sx={{ fontSize: 18 }} />,
  },
  {
    label: REPORTS_SCHEDULER,
    Component: ReportScheduler,
    icon: <ScheduleIcon sx={{ fontSize: 18 }} />,
  },
  
];

function ReportTab({ permissions }) {
    const [value, setValue] = React.useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const filteredTabs = TABS.filter((element) =>
      permissions[element.label]?.canViewMenu == false ||
      permissions[element.label]?.canView == false
        ? false
        : true
    );

    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    

    return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Org's">
            {filteredTabs.map((element, index) => {
              return <Tab iconPosition="start" icon={element.icon} label={element.label} value={index + 1} />;
            })}
          </TabList>
        </Box>
        {filteredTabs.map((element, index) => {
          const Component = element.Component;
          console.log("Report permissions", permissions[element.label]);
          return (
            <TabPanel key={index} value={index + 1}>              
              <Component componentPermissions={permissions[element.label]} />
            </TabPanel>
          );
        })}
      </TabContext>
    </Box>
  );
};

export default ReportTab;
